
import { Form } from 'vee-validate';
import { computed, defineComponent } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import Deferred from '@/core/async/Deferred';
import wishListsStore from '@/b2c/wishlists/wish-lists.store';
import pageStore from '@/shared/content/page.store';
import InputText from '@/shared/form/InputText.vue';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';

export default defineComponent({
    name: 'WishListRename',
    components: { InputText, Form },
    props: {
        title: {
            type: String,
            required: true,
            default: '',
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:show'],
    setup(props, { emit }) {
        const labels = useBlockLabels();
        const id = useRouteQuery(QueryKeys.Id);

        const close = () => {
            emit('update:show', false);
        };

        const titleIsBeingRenamed = computed(() => {
            return props.show;
        });

        const updatePageAltTitle = (): void => {
            pageStore.setAltTitle(wishListsStore.details.name);
        };

        const submitRenamedTitle = async({ editTitle }): Promise<void> => {
            const deferred = new Deferred<void>();
            if (id.value) {
                try {
                    await wishListsStore.updateList(id.value, editTitle || '');
                    close();
                    updatePageAltTitle();
                    deferred.resolve();
                } catch (e) {
                    deferred.reject();
                }
            } else {
                deferred.reject();
            }
            return deferred.promise;
        };

        const validation = {
            editTitle: 'required',
        };

        return {
            labels,
            validation,
            titleIsBeingRenamed,
            close,
            submitRenamedTitle,
        };
    },
});
